/*eslint-disable*/
import React, { useState, useEffect, useContext, useImperativeHandle } from "react";
import {
  Grid,
  Typography,
  TextField,
  Divider,
  Box,
  Button,
  Paper
} from "@mui/material";
import { STYLES } from "config";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";
import { FirebaseContext } from "common";

import { useDispatch, useSelector } from "react-redux";


function StatusComponent(props, ref) {

  const aiMarketingReducer = useSelector((state) => state.aidata);


  const dispatch = useDispatch();

  //Actions
  const { api } = useContext(FirebaseContext);
  const { CreateListing, clearListingErrors, GenerateListingDescription, GenerateListingKeywords, clearAiReducer } =
    api;




  const { data, setvalue } = props;
  const [state, setstate] = useState(data || {});

  useEffect(() => {
    setstate(data || {});
    console.log("Status Component Data:", data);
  }, [data]);

  useEffect(() => {

    console.log('aiMarketingReducer.aiGeneratedKeywords', aiMarketingReducer.aiGeneratedKeywords)

    if (!aiMarketingReducer.loadingKeywords && aiMarketingReducer.completed) {
      setstate({
        ...state,
        metakey: aiMarketingReducer.aiGeneratedKeywords
      });
      dispatch(clearAiReducer());
    }

  }, [aiMarketingReducer.loadingKeywords]);
  useEffect(() => {

    if (!aiMarketingReducer.loadingDescription && aiMarketingReducer.completed) {
      setstate({
        ...state,

        metadesc: aiMarketingReducer.aiGeneratedDescription
      });
      dispatch(clearAiReducer());
    }


  }, [aiMarketingReducer.loadingDescription]);

  const updateData = (e) => {
    const updatedState = { ...state, [e.target.name]: e.target.value };
    setstate(updatedState);
    setvalue(updatedState);
  };

  const handleDropdownChange = (name, value) => {
    const updatedState = { ...state, [name]: value };
    setstate(updatedState);
    setvalue(updatedState);
  };

  useImperativeHandle(props.ref, () => ({
    isValidated() {
      const status = state?.status;
      let isValid = true;

      const newErrors = {};

      if (!status || status === "") {
        newErrors.status = "Status is required";
      }

      setErrors(newErrors);
      return isValid;
    }
  }));

  const handleGenerateKeywords = () => {

    dispatch(GenerateListingKeywords(state));
    console.log("AI Generated Keywords:", aiMarketingReducer);

  };

  const handleGenerateMetaDescription = () => {

    let data = { ...state, markertingHeading: "", description: "" }
    dispatch(GenerateListingDescription(state));
    console.log("Generating Meta Description...", data);
    console.log("AI Generated Meta Description:", aiMarketingReducer);

  };


  const inputStyle = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#003366"
      },
      "&:hover fieldset": {
        borderColor: "#003366"
      }
    }
  };

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" }
  ];

  const airConditionOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" }
  ];

  return (
    <Paper elevation={5} sx={{ height: "100%", width: "100%", maxWidth: "100%", maxHeight: "100%", p: 3 }}>
      <Box sx={{ p: 2 }}>
        {/* Status Section */}
        <Typography variant="h5" gutterBottom sx={{ color: STYLES.WEB_APP_FONT_CLR }}>
          Status
        </Typography>
        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Status<span style={{ color: "red" }}>*</span>:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <CustomDropDownPicker
              required
              name="status"
              value={state?.status || "active"}
              onChange={(value) => handleDropdownChange("status", value)}
              options={statusOptions}
              sx={inputStyle}
            />
          </Grid>
        </Grid>

        {/* Metadata Section */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4, color: STYLES.WEB_APP_FONT_CLR }}>
          Metadata
        </Typography>
        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Typography variant="body1" paragraph sx={{ color: STYLES.WEB_APP_FONT_CLR }}>
          Metadata helps improve how this property listing appears in search engines
          (like Google). It includes a short description (shown in search results)
          and keywords (common search terms). Adding relevant metadata makes your
          listing easier to find online.
        </Typography>

        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>
          {/* Meta Description */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Meta Description:
            </Typography>
          </Grid>
          <Grid item size={5}>
            <TextField
              fullWidth
              multiline
              rows={4}
              name="metadesc"
              placeholder="Example: Spacious 3-bedroom apartment in Cape Town CBD with modern finishes and secure parking."
              value={state?.metadesc || ""}
              onChange={updateData}
              inputProps={{ maxLength: 160 }}
              sx={inputStyle}
            />
            <Typography variant="caption" sx={{ color: STYLES.WEB_APP_FONT_CLR }}>
              Use comma-separated keywords that describe the property. (Max 160 characters)
            </Typography>
          </Grid>
          <Grid item size={5}>
            {/* New: Generate AI Description */}
            <Button
              style={{
                backgroundColor: STYLES.PRIMARY_APP_CLR,
                color: "white",
                width: "fit-content",
                height: 44,
                borderRadius: 8,
                fontSize: 16,
                fontWeight: "bold",
                marginTop: 12,
                display: "flex",
                alignItems: "center",
                gap: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                padding: "0 20px",
                cursor: "pointer"
              }}
              variant="contained"
              color="success"
              onClick={handleGenerateMetaDescription}
              disabled={aiMarketingReducer.loadingDescription}
            >
              <i className="now-ui-icons tech_laptop" style={{ fontSize: 22, marginRight: 8 }} />
              {aiMarketingReducer.loadingDescription ? (
                // Cool loading animation (CSS spinner)
                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: 22,
                      height: 22,
                      border: "3px solid #fff",
                      borderTop: `3px solid ${STYLES.PRIMARY_APP_CLR}`,
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                      marginRight: 8
                    }}
                  />
                  Generating...
                  <style>
                    {`
                                        @keyframes spin {
                                            0% { transform: rotate(0deg);}
                                            100% { transform: rotate(360deg);}
                                        }
                                        `}
                  </style>
                </span>
              ) : (
                "Generate Description with AI"
              )}
            </Button>
          </Grid>


          {/* Keywords */}
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Keywords:
            </Typography>
          </Grid>
          <Grid item size={5}>
            <TextField
              fullWidth
              multiline
              rows={4}
              name="metakey"
              placeholder="Example: Cape Town apartment, CBD rental, 3-bedroom flat, modern apartment"
              value={state?.metakey || ""}
              onChange={updateData}
              sx={inputStyle}
            />
            <Typography variant="caption" sx={{ color: STYLES.WEB_APP_FONT_CLR }}>
              Use comma-separated keywords that describe the property.
            </Typography>
          </Grid>
          <Grid item size={5}>
            <div >
              {/* New: Generate AI Description */}
              <Button
                style={{
                  backgroundColor: STYLES.PRIMARY_APP_CLR,
                  color: "white",
                  width: "fit-content",
                  height: 44,
                  borderRadius: 8,
                  fontSize: 16,
                  fontWeight: "bold",
                  marginTop: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  padding: "0 20px",
                  cursor: "pointer"
                }}
                variant="contained"
                color="success"
                onClick={handleGenerateKeywords}
                disabled={aiMarketingReducer.loadingKeywords}
              >
                <i className="now-ui-icons tech_laptop" style={{ fontSize: 22, marginRight: 8 }} />
                {aiMarketingReducer.loadingKeywords ? (
                  // Cool loading animation (CSS spinner)
                  <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span
                      style={{
                        display: "inline-block",
                        width: 22,
                        height: 22,
                        border: "3px solid #fff",
                        borderTop: `3px solid ${STYLES.PRIMARY_APP_CLR}`,
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                        marginRight: 8
                      }}
                    />
                    Generating...
                    <style>
                      {`
                                        @keyframes spin {
                                            0% { transform: rotate(0deg);}
                                            100% { transform: rotate(360deg);}
                                        }
                                        `}
                    </style>
                  </span>
                ) : (
                  "Generate Keywords with AI"
                )}
              </Button>
            </div>
          </Grid>
        </Grid>

        {/* Extra Section */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4, color: STYLES.WEB_APP_FONT_CLR }}>
          Extra
        </Typography>
        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Typography variant="body1" paragraph sx={{ color: STYLES.WEB_APP_FONT_CLR }}>
          Any Extra information
        </Typography>

        <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item size={2}>
            <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
              Air Condition:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <CustomDropDownPicker
              name="aircondition"
              value={state?.aircondition || "no"}
              onChange={(value) => handleDropdownChange("aircondition", value)}
              options={airConditionOptions}
              sx={inputStyle}
            />
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}

export default StatusComponent;
